/* eslint-disable no-unused-vars */
import { db } from '@/services/firebase.service'

const SHOW_MESSAGE = 'SHOW_MESSAGE'

const state = {
  text: '',
  color: '',
  timeout: '',
}

const getters = {}

const mutations = {
  [SHOW_MESSAGE](state, payload) {
    state.text = payload.text
    state.color = payload.color
    state.timeout = payload.timeout || 3000
  },
}

const actions = {
  showMessage({ commit }, payload) {
    commit('SHOW_MESSAGE', payload)
  },
  info({ commit }, text) {
    commit(SHOW_MESSAGE, { text, color: 'info' })
  },
  success({ commit }, text) {
    commit(SHOW_MESSAGE, { text, color: 'success' })
  },
  error({ commit }, text) {
    commit(SHOW_MESSAGE, { text, color: 'error' })
  },
  warning({ commit }, text) {
    commit(SHOW_MESSAGE, { text, color: 'warning' })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
